module.exports = __webpack_public_path__ + "img/group-toggle-on.c28da629.svg";